import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    Distance: {
        id: 'Search.Results.DoctorCard.Distance',
        defaultMessage: '{distance, number}mi',
    },

    OutOfNetwork: {
        id: 'Search.Results.DoctorCard.ProviderOutOfNetwork',
        defaultMessage: 'Out-of-network',
    },

    PreviewDoctorInsurance: {
        id: 'Search.Results.DoctorCard.PreviewDoctorInsurance',
        defaultMessage: 'Insurance info unavailable',
    },

    SponsoredText: {
        id: 'Search.Results.SponsoredBanner.SponsoredText',
        defaultMessage: 'Sponsored',
    },

    SponsoredTelemedicineText: {
        id: 'Search.Results.SponsoredTelemedicineBanner.SponsoredText',
        defaultMessage: 'Sponsored Telemedicine',
    },

    ViewProfile: {
        id: 'Search.Results.DoctorCard.ViewProfile',
        defaultMessage: 'View the profile of {name}',
    },
});
